import { RefObject, useCallback, useState } from "react";

import { useEscapeKey, useEventOutsideRefs, usePortalNode } from "../hooks";

interface DrawerHook {
  (props: {
    onClose?: () => void;
    ref: RefObject<HTMLElement>;
    visible: boolean;
  }): {
    isHidden: boolean;
    portalNode: HTMLElement | null;
    setIsHidden: (isHidden: boolean) => void;
  };
}

export const useDrawer: DrawerHook = ({ onClose, ref, visible }) => {
  const portalNode = usePortalNode();
  const [isHidden, setIsHidden] = useState(!visible);
  const close = useCallback(() => {
    if (visible && onClose) {
      onClose();
    }
  }, [onClose, visible]);

  useEscapeKey(close, visible, [close]);
  useEventOutsideRefs([ref], ["mousedown", "touchstart"], close, {
    deps: [close, visible],
  });

  return { isHidden, portalNode, setIsHidden };
};
